/** @file Billing credentials section */

import React from 'react';
import { Box, SxProps, TextField, Typography } from '@mui/material';
import { testId as parentTestId } from '../util';
import { BillingCredentialData } from '../../../store/modules/merchant/types';

export const testId = `${parentTestId}-BILLING_CREDENTIALS`;

type Props = {
  billingCredential?: BillingCredentialData;
  onBillingCredentialChange: (arg0: BillingCredentialData) => any;
  sx?: SxProps;
  disabled?: boolean;
};

/**
 * Billing credentials section of Payments and Processing
 * @param {Props} props Component Properties
 * @returns {JSX.Element}
 */
const BillingCredentials = ({
  billingCredential,
  onBillingCredentialChange,
  sx = {},
  disabled,
}: Props) => {
  const onChangeMID = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updatedCredential: BillingCredentialData = {
      billingChainId: billingCredential?.billingChainId ?? '',
      billingMid: e.target.value,
    };
    onBillingCredentialChange(updatedCredential);
  };

  const onChangeChainID = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updatedCredential: BillingCredentialData = {
      billingMid: billingCredential?.billingMid ?? '',
      billingChainId: e.target.value,
    };
    onBillingCredentialChange(updatedCredential);
  };

  return (
    <Box sx={sx} component="section" data-testid={testId}>
      <Typography variant="large" fontWeight="bold" sx={{ mb: 2 }}>
        Billing Credentials
      </Typography>
      <Typography variant="small" color="text.secondary">
        In order to be properly billed, please fill out the following credentials.
      </Typography>
      <Box sx={{ mt: 3, width: { xs: '100%', sm: '448px' } }}>
        <TextField
          value={billingCredential?.billingMid ?? ''}
          onChange={onChangeMID}
          label="Worldpay Billing MID"
          data-testid={`${testId}-MID`}
          disabled={disabled}
        />
      </Box>
      <Box sx={{ mt: 3, width: { xs: '100%', sm: '448px' } }}>
        <TextField
          value={billingCredential?.billingChainId ?? ''}
          onChange={onChangeChainID}
          label="Worldpay Billing Chain ID"
          data-testid={`${testId}-CHAIN_ID`}
          disabled={disabled}
        />
      </Box>
    </Box>
  );
};

export default BillingCredentials;
